
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/call",
      function () {
        return require("private-next-pages/call.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/call"])
      });
    }
  